import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../../store";
import { baseURL } from "../../../service/HttpService";

export interface AuthConfigState {
	isSSOEnabled: boolean;
	isLoaded: boolean;
}

const initialState: AuthConfigState = {
	isSSOEnabled: false,
	isLoaded: false
};

const authConfigSlice = createSlice({
	name: "authConfig",
	initialState,
	reducers: {
		setAuthConfig: (state, { payload }: PayloadAction<{ isSSOEnabled: boolean }>) => {
			state.isSSOEnabled = payload.isSSOEnabled;
			state.isLoaded = true;
		}
	},
});

export const loadAuthConfig = (): AppThunk => async (dispatch) => {
	try {
		const res = await fetch(`${baseURL}api/v1/auth/config`, {
			method: "GET",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		}).then((res) => res.json());

		dispatch(setAuthConfig({ isSSOEnabled: res.isSSOEnabled }));
		sessionStorage.setItem("isSSOEnabled", res.isSSOEnabled ? "true" : "false");
	} catch {
		dispatch(setAuthConfig({ isSSOEnabled: false }));
		sessionStorage.setItem("isSSOEnabled", "false");
	}
};

export const { setAuthConfig } = authConfigSlice.actions;
export default authConfigSlice.reducer;
